import { render, staticRenderFns } from "./SignatureDocuments.vue?vue&type=template&id=bb346346&scoped=true"
import script from "./SignatureDocuments.vue?vue&type=script&lang=js"
export * from "./SignatureDocuments.vue?vue&type=script&lang=js"
import style0 from "./SignatureDocuments.vue?vue&type=style&index=0&id=bb346346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb346346",
  null
  
)

export default component.exports